<template>
  <div class="page">
    <div class="header-banner">
      <img src="@/assets/sb-top.png" class="header-image" />
      <div class="header-title">智能垃圾回收站满溢系统</div>
    </div>

    <div class="layout">
      <!-- 左侧统计（由接口数据汇总） -->
      <div class="left-panel">
        <div class="icon-block" v-for="(item, index) in iconList" :key="index">
          <img :src="require(`@/assets/${item.icon}`)" class="left-icon" />
          <div class="label-group">
            <div class="label-item">
              <div class="label-text">{{ item.low.label }} {{ item.low.value }}</div>
            </div>
            <div class="label-item">
              <div class="label-text">{{ item.high.label }} {{ item.high.value }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧内容（各小区/设备） -->
      <div class="container">
        <div class="area-wrapper">
          <!-- 🔄 加载遮罩：可见但不改变尺寸 -->
          <div v-if="loading" class="area-loading">
            <dv-loading class="white-loading"></dv-loading>
          </div>

          <div class="area-card" v-for="(area, areaIndex) in areaList" :key="areaIndex">
            <div class="pond-box">
              <div class="pond-item">
                <img src="@/assets/ljt1.svg" alt="logo" class="icon" />
                <div class="label">{{ area.name }}</div>
              </div>
              <div class="pond-item" v-for="(item, itemIndex) in area.data" :key="itemIndex">
                <dv-water-level-pond :config="getPondConfig(item.value)" style="width: 100px; height: 100px" />
                <div class="label">{{ item.label }}</div>
              </div>
            </div>
          </div>

          <!-- 无数据占位 -->
          <div v-if="!loading && !areaList.length" class="area-empty">暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/utils/request'

export default {
  data() {
    return {
      // 🔄 加载态，控制右侧遮罩
      loading: true,

      // 左侧统计：将由 computeIconStats 基于 areaList 计算覆盖
      iconList: [
        { icon: 'yw.svg', low: { label: '低位满溢', value: 0 }, high: { label: '高位满溢', value: 0 } }, // 衣物
        { icon: 'js.svg', low: { label: '低位满溢', value: 0 }, high: { label: '高位满溢', value: 0 } }, // 金属
        { icon: 'fz.svg', low: { label: '低位满溢', value: 0 }, high: { label: '高位满溢', value: 0 } }, // 废纸
        { icon: 'sl.svg', low: { label: '低位满溢', value: 0 }, high: { label: '高位满溢', value: 0 } }  // 塑料
      ],
      // 右侧区域卡片：由接口生成
      areaList: [],
      // 类别与左侧 icon 的对应关系
      categoryIconMap: {
        '衣物': 'yw.svg',
        '金属': 'js.svg',
        '废纸': 'fz.svg',
        '塑料': 'sl.svg'
      },
      // 阈值
      LOW_THRESHOLD: 33,
      HIGH_THRESHOLD: 66
    }
  },
  mounted() {
    this.getdevice()
  },
  methods: {
    // 水位配置 + 颜色
    getPondConfig(value) {
      let colors
      if (value >= this.HIGH_THRESHOLD) colors = ['#FF5A5A', '#FF9B9B']
      else if (value <= this.LOW_THRESHOLD) colors = ['#FFC043', '#FFD48A']
      else colors = ['#2AD180', '#7BE3B0']
      return {
        data: [value],
        shape: 'round',
        waveNum: 2,
        waveHeight: 8,
        colors
      }
    },
    // demo：90% 概率低位、10% 概率高位（替换为接口真实值即可）
    randomPercent() {
      return Math.random() < 0.9 ? this.LOW_THRESHOLD : this.HIGH_THRESHOLD
    },
    isValidName(name) {
      const n = String(name || '').trim()
      return n && n !== '未命名设备'
    },
    buildAreaEntry(deviceName) {
      const categories = ['废纸', '塑料', '金属', '衣物']
      return {
        name: deviceName,
        data: categories.map(label => ({ label, value: this.randomPercent() })) // TODO: 用接口返回的百分比替换
      }
    },
    // 基于 areaList 汇总左侧 iconList（≤33 低位，≥66 高位）
    computeIconStats() {
      const c = { '衣物': { low: 0, high: 0 }, '金属': { low: 0, high: 0 }, '废纸': { low: 0, high: 0 }, '塑料': { low: 0, high: 0 } }
      this.areaList.forEach(area => {
        (area.data || []).forEach(item => {
          const v = Number(item.value)
          if (v >= this.HIGH_THRESHOLD) c[item.label].high += 1
          else if (v <= this.LOW_THRESHOLD) c[item.label].low += 1
        })
      })
      this.iconList = Object.keys(this.categoryIconMap).map(cat => ({
        icon: this.categoryIconMap[cat],
        low: { label: '低位满溢', value: c[cat].low },
        high: { label: '高位满溢', value: c[cat].high }
      }))
    },
    getdevice() {
      this.loading = true
      request({
        url: 'https://anjat.bolerunjing.cn/An74/api/order/weight_by_device',
        method: 'get'
      })
        .then(res => {
          const rows = Array.isArray(res?.data?.data) ? res.data.data : []
          // 构建区域列表，并剔除“未命名设备”
          const list = rows
            .map(item => (this.isValidName(item?.device_name) ? this.buildAreaEntry(String(item.device_name).trim()) : null))
            .filter(Boolean)

          this.areaList = list
          this.computeIconStats()
        })
        .catch(err => {
          console.error('获取设备失败：', err)
          this.areaList = []
          this.computeIconStats()
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.page {
  width: 100vw;
  height: 100vh;
  background-image: url('@/assets/deviceInfo-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow-y: auto;
}

.layout {
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  padding: 30px;
  height: calc(100vh - 60px);
  box-sizing: border-box;
}

.left-panel {
  width: 380px;                 /* 固定宽，右侧自适应 */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  padding: 20px 10px;
  box-sizing: border-box;
}

.container {
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 右侧滚动容器：固定高度，加载时不缩 */
.area-wrapper {
  position: relative;           /* 让遮罩绝对定位 */
  border: 2px solid #00ffff;
  border-radius: 10px;
  padding: 40px;
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 80px);
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 20px rgba(0, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
  gap: 40px;
  overflow-y: auto;
  scrollbar-width: none;
}
.area-wrapper::-webkit-scrollbar { width: 0; height: 0; }

/* loading 遮罩（不改变尺寸） */
.area-loading {
  position: absolute;
  inset: 0;
  background: rgba(0, 10, 20, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
}

/* 每个小区的外框 */
.area-card {
  border: 2px solid #00ffff;
  border-radius: 15px;
  padding: 20px;
  width: 950px;
  max-width: 100%;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.4);
  margin: 0 auto;
}

.pond-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pond-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 15px;
}

.icon {
  width: 100px;
  height: 100px;
  /* border: 3px solid black; */
  /* border-radius: 50%; */
  /* background-color: white; */
  object-fit: contain;
  padding: 10px;
}

.label {
  margin-top: 10px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
}

/* 左侧图标统计样式 */
.icon-block { display: flex; align-items: center; gap: 16px; }
.left-icon { width: 100px; height: 100px; border: 3px solid #00ffff; border-radius: 50%; object-fit: contain; }
.label-group { display: flex; flex-direction: column; justify-content: center; color: #00ffff; font-weight: bold; font-size: 22px; line-height: 1.5; }
.label-text { font-size: 22px; }

.header-banner { position: relative; width: 100%; height: 120px; overflow: hidden; }
.header-image { width: 100%; height: 140%; object-fit: cover; }
.header-title { position: absolute; top: 40%; left: 50%; transform: translate(-50%, -50%); color: #00ffff; font-size: 36px; font-weight: bold; text-shadow: 0 0 10px rgba(0, 255, 255, 0.8); white-space: nowrap; }
</style>
